const formControlModalCloneCheckSite = {
  from: 'CLONING OF:',
  to: 'CLONING TO:',
  text: 'SELECT THE SERVICE TYPES YOU WANT TO CLONE:'
};

export default formControlModalCloneCheckSite;
